module.exports = __webpack_public_path__ + "static/media/handpiece.75d04b4a.svg";